import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'intval',
})
export class IntvalPipe implements PipeTransform {

  transform(value: number) {

    return Math.trunc(value);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/intval/intval.ts